module.exports = __webpack_public_path__ + "static/media/invoice-money.a207018e.svg";